import React , {useRef,useState,useEffect} from 'react';
// import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import { getList } from '../APICalls/FormCalls';
import { ANALYTICS } from '../../../commons/api';
// import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Input,
  Tooltip,
  Breadcrumb
} from 'antd';

const APIList = {
  getList: `${ANALYTICS.UseCaseGet}`,
  PredictionGet: `${ANALYTICS.PredictionGetById}`,
  TrainingJobGet: `${ANALYTICS.TrainingJobGetById}`
  // Edit: `${ANALYTICS.UseCaseGet}`
};
const Home = (props) => {

  const [dataSource,setDataSource] = useState([]);
  // const [lastBreadcrumb,setLastBreadcrumb] = useState ('home');
  const [breadcrumbList] = useState ([
    {
      title: '',
      key: 'home',
      type: 'home'
    }
  ]);
  const [searchText,setSearchText] = useState ('');
  const [searchedColumn,setSearchedColumn] = useState ();
  const [translationCache,setTranslationCache] = useState (props.translationCache || {});
  const [userProfile,setUserProfile] = useState (props && props.userProfile ? props.userProfile : {});
  const searchInputRef = useRef(null);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await getList(APIList.getList);
        setDataSource(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error('Failed to fetch :', error);
        setDataSource([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (
      translationCache !== props.TranslationCache ||
      userProfile !== props.UserProfile
    ) {
      setTranslationCache(translationCache);
      setUserProfile(userProfile);
    }
  }, [translationCache, userProfile, props.TranslationCache, props.UserProfile]);
  
  

  // const editList =  (Id, record) => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   const object = {
  //     method: 'GET',
  //     url: `${APIList.getList}?SiteId=${siteId}&Id=${Id}&Type=Usecase`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     },
  //     data: record
  //   };
  //   return axios(object)
  //     .then((response) => {
  //       return response && response.data;
  //     })
  //     .catch(function () { });
  // };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

   const _editRecord = (record) => {
    props.navigate(
      `/rubus/RubusAnalytics/usecase/${record.Id}`
    );
  };

  const addUsecase = () => {
    props.navigate(
      '/rubus/RubusAnalytics/usecase/New',
      {
        state: breadcrumbList
      }
    );
  };
 const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          Search
        </Button>
        <Button
          type='primary'
          danger
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    
      setSearchText(selectedKeys[0]),
      setSearchedColumn(dataIndex);
    
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };


    let columns = [
      {
        title: translation('UseCase Name'),
        dataIndex: 'UseCaseName',
        key: 'UseCaseName',
        ...getColumnSearchProps('UseCaseName')
      },
      {
        title: translation('Description'),
        dataIndex: 'Description',
        key: 'Description'
      },
      {
        title: translation('Action'),
        width: '600',
        render: (text, record) => (
          <>
            <Button
              style={{ marginRight: '5px' }}
              type='primary'
              onClick={() => _editRecord(record)}
            >
              <Tooltip title={translation('Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
          </>
        )
      }
    ];

    return (
      <>
        <div>
          <Breadcrumb
            style={{
              padding: '20px 0px 10px 35px',
              // color: 'white',
              fontWeight: '800'
            }}
            separator=">"
            className="_Bredacrumb_"
          >
            {breadcrumbList &&
              Array.isArray(breadcrumbList) &&
              breadcrumbList.map((breadcrumb, index) => {
                if (
                  breadcrumb &&
                  breadcrumb.type &&
                  breadcrumb.type === 'home' &&
                  breadcrumbList.length === 1
                ) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        // onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {''}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.type && breadcrumb.type === 'home') {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        // onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if ((breadcrumb.type === 'Prediction' || breadcrumb.type === 'Analysis') &&
                  (breadcrumb && breadcrumb.Id)) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        // to={`/rubus/RubusAnalytics/Tasks/${breadcrumb.Id}?AnalyticsId=${analyticsId}&Type=${type}`}
                        // onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb.type === 'Prediction' || breadcrumb.type === 'Analysis') {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/Tasks/New`}
                        // onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.Id) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/${breadcrumb.Id}`}
                        // onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/New`}
                        // onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                }
              })}
          </Breadcrumb>
          <>
            <div style={{ float: 'right' }}>
              <Tooltip title={translation('Add Use Case')}>
                <PlusOutlined
                  onClick={() => addUsecase()}
                  style={{
                    
                    color: 'rgb(255, 108, 0)',
                    marginLeft: '10px',
                    paddingBottom: '20px',
                    paddingRight: '20px'
                  }}
                />
              </Tooltip>
            </div>
            <div>
              <StyledTable size="small"
                dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
                columns={columns}
              />
            </div>
          </>
        </div>
      </>
    );
  
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(Home);
